import { render, staticRenderFns } from "./ProductNameWithActions.vue?vue&type=template&id=36f6a0f3&scoped=true"
import script from "./ProductNameWithActions.vue?vue&type=script&lang=js"
export * from "./ProductNameWithActions.vue?vue&type=script&lang=js"
import style0 from "./ProductNameWithActions.vue?vue&type=style&index=0&id=36f6a0f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6a0f3",
  null
  
)

export default component.exports